import React, { useState, useEffect } from 'react';
import { Menubar } from 'primereact/menubar';
import { Button } from 'primereact/button';
import { useNavigate, useLocation } from 'react-router-dom';

function Navbar({ onLogout }) {
  const navigate = useNavigate();

  const items = [
    {
      label: 'Startseite',
      command: () => navigate('/module'),
      className: location.pathname === '/module' ? 'active-link' : ''
    },
    {
      label: 'Praxis 1',
      command: () => navigate('/module/pm1'),
      className: location.pathname === '/module/pm1' ? 'active-link' : ''
    },
    {
      label: 'Praxis 2',
      command: () => navigate('/module/pm2'),
      className: location.pathname === '/module/pm2' ? 'active-link' : ''
    },
    {
      label: 'Gesundheit & Pflege',
      command: () => navigate('/module/gp'),
      className: location.pathname === '/module/gp' ? 'active-link' : ''
    },
    {
      label: 'Organisation & Planung',
      command: () => navigate('/module/op'),
      className: location.pathname === '/module/op' ? 'active-link' : ''
    }
  ];

  const start = (
    <img src="/favicon.png" alt="Logo" style={{ height: '32px', marginLeft: '10px', marginRight: '10px' }} />
  );

  const end = (
    <Button
      label="Logout"
      icon="pi pi-sign-out"
      className="p-button-danger"
      onClick={onLogout}
    />
  );

  return <Menubar model={items} start={start} end={end} />;
}

export default Navbar;